import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
/*
 * Constants.ts
 */
export class ApiConstants extends SlingoConstants {
}
ApiConstants.PROPERTY_PARAMS_TOTAL = "total";
ApiConstants.PROPERTY_PARAMS_PICKS = "picks";
ApiConstants.PROPERTY_PARAMS_GOLDFISH = "goldfish";
ApiConstants.PROPERTY_PARAMS_BONUS_GAME_DATA = "bonusGameData";
ApiConstants.PROPERTY_PARAMS_INITIAL_PICKS = "initialPicks";
ApiConstants.PROPERTY_PARAMS_INITIAL_GOLDFISH = "initialGoldFish";
ApiConstants.PROPERTY_PARAMS_MISSED_BUBBLES = "missedBubbles";
ApiConstants.PROPERTY_PARAMS_MISSED_BUBBLE_TOTAL_GOLDFISH = "totalGoldFish";
ApiConstants.PROPERTY_PARAMS_MISSED_BUBBLE_TOTAL_PICKS = "totalPicks";
ApiConstants.PROPERTY_PARAMS_MISSED = "missed";
ApiConstants.PROPERTY_PARAMS_MISSES = "misses";
ApiConstants.PROPERTY_PARAMS_FISH_FOOD_PRIZES = "fishFoodPrizes";
ApiConstants.PROPERTY_CHANCE_GAME = "chanceGame";
ApiConstants.PROPERTY_ID = "id";
ApiConstants.PROPERTY_GAME_CONFIG = "gameConfig";
ApiConstants.PROPERTY_GAME_CONFIG_ID = "id";
ApiConstants.PROPERTY_GAME_CONFIG_MULTIPLIER = "multiplier";
ApiConstants.PROPERTY_GAMES = "games";
ApiConstants.PROPERTY_PAYOUT = "payout";
ApiConstants.PROPERTY_STAKE = "stake";
ApiConstants.PROPERTY_TOTAL_WIN = "totalWin";
ApiConstants.PROPERTY_CURRENCY_CODE = "currencyCode";
ApiConstants.PROPERTY_PARAMS = "params";
ApiConstants.PROPERTY_PARAMS_MULTIPLER = "multiplier";
ApiConstants.PROPERTY_SLOTS_SPINS = "slotsSpins";
ApiConstants.PROPERTY_ADDITIONAL_COLUMNS = "additionalColumns";
ApiConstants.PROPERTY_SYMBOLS = "symbols";
ApiConstants.PROPERTY_PAYOUTS = "payouts";
ApiConstants.PROPERTY_COLUMN = "column";
ApiConstants.PROPERTY_ROW = "row";
ApiConstants.PROPERTY_LOCKED = "locked";
ApiConstants.PROPERTY_MULTIPLIER = "multiplier";
ApiConstants.PROPERTY_WIN_MULTIPLIER = "winMultiplier";
ApiConstants.PROPERTY_WIN = "win";
//Feature Spin Params
//public static PROPERTY_PARAMS: string = "params";
ApiConstants.PROPERTY_PARAMS_EFFECT_FREQUENCIES = "effectFrequencies";
ApiConstants.PROPERTY_PARAMS_EFFECT_MULTIPLIER = "effectMultiplier";
ApiConstants.PROPERTY_PARAMS_ORIGINAL_AMOUNT = "originalAmount";
ApiConstants.PROPERTY_PARAMS_EFFECT_TARGETS = "effectTargets";
ApiConstants.PROPERTY_PARAMS_ORIGINAL_MULTIPLIER = "originalMultiplier";
//Feature Slots
ApiConstants.PROPERTY_SLOTS_GAME = "slotsGame";
ApiConstants.PROPERTY_SPIN_TYPE = "spinType";
ApiConstants.PROPERTY_REEL_SET = "reelSet";
ApiConstants.PROPERTY_REELS = "reels";
ApiConstants.PROPERTY_GAME_ID = "gameId";
ApiConstants.PROPERTY_COMPLETION_REASON = "NO_PURCHASE_SPIN";
ApiConstants.PROPERTY_COMPLETION_DATE = "completionDate";
ApiConstants.PROPERTY_STANDARD_SPINS = "standardSpins";
ApiConstants.PROPERTY_STANDARD_SPINS_REMAINING = "standardSpinsRemaining";
ApiConstants.PROPERTY_STANDARD_SPINS_USED = "standardSpinsUsed";
ApiConstants.PROPERTY_FREE_SPINS = "freeSpins";
ApiConstants.PROPERTY_FREE_SPINS_USED = "freeSpinsUsed";
ApiConstants.PROPERTY_FREE_SPINS_REMAINING = "freeSpinsRemaining";
ApiConstants.PROPERTY_FREE_SPINS_TRIGGERED = "freeSpinsTriggered";
//public static PROPERTY_TOTAL_WIN: string = "totalWin";
ApiConstants.PROPERTY_TOTAL_STAKE = "totalStake";
ApiConstants.PROPERTY_FEATURE = "feature";
ApiConstants.PROPERTY_EXPAND_COLUMNS = "expandColumns";
//public static PROPERTY_CURRENCY_CODE: string = "currencyCode";
ApiConstants.PROPERTY_JOKER_MULTIPLIERS = "jokerMultipliers";
ApiConstants.PROPERTY_SUPER_JOKER_MULTIPLIERS = "superJokerMultipliers";
ApiConstants.PROPERTY_COIN_MULTIPLIERS = "coinMultipliers";
//# sourceMappingURL=Constants.js.map